import React from "react";
import "./JoinFundraiser.css";
import JoinFundraiserForm from "../../components/Forms/JoinFundraiserForm";

const ParticipantJoinFundraiser = () => {
  return <JoinFundraiserForm />;
};

export default ParticipantJoinFundraiser;
